<template>
  <SubtleConfirmationModal
    v-model="isOpen"
    :title="toggleLabel"
    :confirm-label="toggleLabel"
    @confirm="confirm"
  >
    <p class="text-[#B7B7B7] text-sm font-normal font-sans leading-normal">
      {{ toggleBody }}
    </p>

    <slot></slot>
  </SubtleConfirmationModal>
</template>

<script setup lang="ts">
import { useTranslationStore } from "@/stores/translation.store";
import SubtleConfirmationModal from "../ui/modal/subtle-confirmation-modal.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const isOpen = defineModel<boolean>({ required: true });

const _emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();

const translationStore = useTranslationStore();

const toggleLabel = computed(() =>
  translationStore.autoTranslateOn
    ? t("channel.translation.toggle.turnOff")
    : t("channel.translation.toggle.turnOn"),
);
const toggleBody = computed(() =>
  translationStore.autoTranslateOn
    ? t("channel.translation.toggle.profileHint.on")
    : t("channel.translation.toggle.profileHint.off"),
);

function confirm() {
  translationStore.toggleAutoTranslate();
}
</script>
